import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import EmblaCarousel from 'embla-carousel';
import Player from '@vimeo/player';


// Alpine plugins

Alpine.plugin(collapse);
Alpine.plugin(focus);


// Sliders

window.initSlider = () => ({
    embla: null,
    isFirstSlide: true,
    isLastSlide: false,
    init() {
        this.embla = EmblaCarousel(this.$refs.embla, {
            align: 'start',
            loop: this.$refs.embla.dataset.loop === 'true',
        });

        this.embla.on('select', this.handleSelect.bind(this));
        this.handleSelect();

        const autoplay = this.$refs.embla.dataset.autoplay;

        if (autoplay) {
            setInterval(() => {
                if (!this.isLastSlide || loop) {
                    this.scrollNext();
                }
            }, autoplay);
        }
    },
    handleSelect() {
        this.isFirstSlide = !this.embla.canScrollPrev();
        this.isLastSlide = !this.embla.canScrollNext();
    },
    scrollPrev() {
        this.embla?.scrollPrev();
    },
    scrollNext() {
        this.embla?.scrollNext();
    }
});


// Hero video and animation

window.initHero = () => {
    let player;

    return {
        loaded: false,
        playing: true,
        init() {
            const iframe = this.$el.querySelector('iframe');

            if (iframe) {
                player = new Player(iframe);
                player.on('play', () => this.loaded = true);
            }

            // if (this.$refs.animation) {
            //     window.addEventListener('scroll', () => {
            //         this.$refs.animation.style.transform = `translateX(${Math.max(0, 0.5 * window.scrollY)}px)`;
            //     });
            // }
        },
        togglePlay() {
            if (player) {
                this.playing = !this.playing;
                player.getPaused().then(paused => player[paused ? 'play' : 'pause']());
            }
        },
    }
};


// Start Alpine

Alpine.start();


// Moving eye pupils

const pupilPairs = document.querySelectorAll('.pupils');

pupilPairs.forEach(pupils => {
    if (!window.matchMedia('(min-width: 60em)').matches) {
        pupils.style.transform = 'translate(0, 10%)';
        return;
    }

    let pupilsX, pupilsY;

    function updatePupilsPosition() {
        const pupilsRect = pupils.getBoundingClientRect();

        pupilsX = pupilsRect.x + pupilsRect.width / 2;
        pupilsY = pupilsRect.y + pupilsRect.height / 2;
    }

    window.addEventListener('resize', updatePupilsPosition);
    window.addEventListener('scroll', updatePupilsPosition);

    window.addEventListener('mousemove', e => {
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        const relativeX = mouseX - pupilsX;
        const relativeY = mouseY - pupilsY;

        // console.log(`Mouse Position: (${mouseX}, ${mouseY})`);
        // console.log(`Pupils Position: (${pupilsX}, ${pupilsY})`);
        // console.log(`Relative Position: (${relativeX}, ${relativeY})`);

        let transformX, transformY;

        if (mouseX < pupilsX && mouseY < pupilsY) { // Left top
            transformX = relativeX / pupilsX * 10;
            transformY = relativeY / pupilsY * 10;
        } else if (mouseX > pupilsX && mouseY < pupilsY) { // Right top
            transformX = relativeX / (window.innerWidth - pupilsX) * 10;
            transformY = relativeY / pupilsY * 10;
        } else if (mouseX < pupilsX && mouseY > pupilsY) { // Left bottom
            transformX = relativeX / pupilsX * 10;
            transformY = relativeY / (window.innerHeight - pupilsY) * 10;
        } else if (mouseX > pupilsX && mouseY > pupilsY) { // Right bottom
            transformX = relativeX / (window.innerWidth - pupilsX) * 10;
            transformY = relativeY / (window.innerHeight - pupilsY) * 10;
        }

        pupils.style.transform = `translate(${transformX}%, ${transformY}%)`;
    });
});


// Animations on scroll

const animatedItems = document.querySelectorAll('.animates');

function triggerScrollAnimation(items) {
    items.forEach(item => {
        const y = item.getBoundingClientRect().y;

        if (y < window.innerHeight) {
            if (!item.classList.contains('animated')) {
                item.classList.add('animated');
            }
        } else {
            item.classList.remove('animated');
        }
    });
}

function forceScrollAnimation() {
    window.dispatchEvent(new Event('scroll'));
}

if (animatedItems.length) {
    window.addEventListener('scroll', () => triggerScrollAnimation(animatedItems));
    triggerScrollAnimation(animatedItems);
}